import { cn } from '@/utils/utils';
import React, { useEffect, useRef } from 'react';
import Rellax from 'rellax';

const ParallaxImage: React.FC<{
    src: string,
    alt?: string,
    speed?: number,
    className?: string
}> = ({ src, alt = '', speed = -1.8, className = '' }) => {
    const imgRef = useRef<HTMLImageElement>(null);
    const rellaxRef = useRef<Rellax | null>(null);

    useEffect(() => {
        if (imgRef.current) {
            rellaxRef.current = new Rellax(imgRef.current, {
                speed,
                center: true,
                round: true,
                vertical: true,
                horizontal: false
            });

            return () => {
                rellaxRef.current?.destroy();
                rellaxRef.current = null;
            };
        }
    }, [speed]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            if (rellaxRef.current) {
                rellaxRef.current.refresh(); // Gọi lại refresh khi trang thay đổi chiều cao
            }
        });

        // Theo dõi toàn bộ trang
        resizeObserver.observe(document.body);

        return () => {
            resizeObserver.disconnect(); // Hủy theo dõi khi component unmount
        };
    }, []);

    return (
        <img
            ref={imgRef}
            src={src}
            alt={alt}
            className={cn('rellax', className)}
            loading='lazy'
        />
    );
};

export default ParallaxImage;
